import BaseValidationController from "../admin/controllers/forms/base_validation_controller.js";

export default class extends BaseValidationController {
  static rules = {
    student_email: { presence: { allowEmpty: false }, email: true },
    student_name: { presence: { allowEmpty: false } },
    mentor_email: { presence: { allowEmpty: false }, email: true },
    mentor_name: { presence: { allowEmpty: false } },
    reason: { presence: { allowEmpty: false } },
    student_author_age: { presence: { allowEmpty: false }, numericality: { onlyInteger: true, greaterThanOrEqualTo: 0 } },
    manuscript_title: { presence: { allowEmpty: false } },
    manuscript_hypothesis: { presence: { allowEmpty: false } },
    average_income: { presence: { allowEmpty: false }, numericality: { onlyInteger: true, greaterThanOrEqualTo: 0 } },
    student_country: { presence: { allowEmpty: false } },
    ethical_approval: { presence: { allowEmpty: false } }
  };

  afterValidate({ el, attr }) {
    if (attr === "student_email" || attr === "mentor_email") {
      this._validateEmailsDiffer(attr);
    }
    if (attr === "ethical_approval") {
      this._validateRadioSelected(el, attr);
    }
    super.afterValidate({ el, attr });
  }

  _validateRadioSelected(el, attr) {
    const radios = this.element.querySelectorAll(`[data-attr='waiver-validation.${attr}']`);
    const anyChecked = Array.from(radios).some(r => r.checked);
    if (!anyChecked) {
      this.errors.add(attr, "Please select an option");
    }
  }

  _validateEmailsDiffer(attr) {
    const studentEl = this.element.querySelector("[data-attr='waiver-validation.student_email']");
    const mentorEl = this.element.querySelector("[data-attr='waiver-validation.mentor_email']");
    if (!studentEl || !mentorEl) return;

    const student = (studentEl.value || "").trim().toLowerCase();
    const mentor = (mentorEl.value || "").trim().toLowerCase();

    if (student && mentor && student === mentor) {
      this.errors.add(attr, "Mentor email must be different from the student author's email");
    }
  }
}

